module.exports = __webpack_public_path__ + "static/media/25488225_1703509016390949_4292259497290054360_o.b6b7b8d3.jpg";